export enum Connector {
  MetaMask = 'MetaMask',
  TrustWallet = 'TrustWallet',
  WalletConnect = 'WalletConnect',
  SafePal = 'SafePal',
  CoinbaseWallet = 'CoinbaseWallet',
  BinanceChainWallet = 'BinanceChainWallet',
  BraveWallet = 'BraveWallet',
  InfinityWallet = 'InfinityWallet',
  OperaWallet = 'OperaWallet',
  BitKeep = 'BitKeep',
  TokenPocket = 'TokenPocket',
}
